<template>
  <div id="page-user-view pt-20">
    <div class="">
      <template>
        <vs-navbar class="p-2">
          <div slot="title" class="nav-img-for-gu">
            <vs-navbar-title>
              <img src="@/assets/images/pages/logo.png" alt="">
            </vs-navbar-title>
          </div>

          <vs-navbar-item index="0">

          </vs-navbar-item>

          <vs-navbar-item index="1">

          </vs-navbar-item>

          <vs-navbar-item index="2">

          </vs-navbar-item>
        </vs-navbar>
      </template>
    </div>
    <div id="user-data">
      <vx-card title="Applicant and Purchase Information">


      <vx-card title="Personal Information" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
                        <img :src="userInfo.ekyc.parsonal.photo" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div v-if="userInfo.ekyc.parsonal !== null" class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">First Name</td>
                <td>{{ userInfo.ekyc.parsonal.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Last Name</td>
                <td>{{ userInfo.ekyc.parsonal.last_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Father’s Name</td>
                <td>{{ userInfo.ekyc.parsonal.father_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mother’s Name</td>
                <td>{{ userInfo.ekyc.parsonal.mother_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Spouse Name</td>
                <td>{{ userInfo.ekyc.parsonal.spouse_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Age</td>
                <td>{{ userInfo.ekyc.parsonal.age }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Marital Status</td>
                <td>{{ userInfo.ekyc.parsonal.marital_status }}</td>
              </tr>


            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div v-if="userInfo.ekyc.parsonal !== null" class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Gender</td>
                <td>{{ userInfo.ekyc.parsonal.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Head of Household</td>
                <td>{{ userInfo.ekyc.parsonal.head_of_household  === 'true'?'Yes':'No'}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Education Level</td>
                <td>{{ userInfo.ekyc.parsonal.education_level }}</td>
              </tr>
              <tr>
                <td class="font-semibold">NID No</td>
                <td>{{ userInfo.ekyc.parsonal.nid }}</td>
              </tr>
              <tr>
                <td>
                  Photo From NID
                </td>
                <td>
                  <img @click="popupActive=true" class="nidImg" :src="userInfo.ekyc.parsonal.nid_photo" alt="">
                </td>
              </tr>
<!--              <tr v-if="userInfo.ekyc.parsonal.nid_front">
                <td class="font-semibold">NID Front</td>
                <td><img @click="popupActive=true" class="nidImg" :src="userInfo.ekyc.parsonal.nid_front" alt=""></td>
              </tr>
              <tr v-if="userInfo.ekyc.parsonal.nid_back">
                <td class="font-semibold">NID  Back</td>
                <td><img @click="popupActive3=true" class="nidImg" :src="userInfo.ekyc.parsonal.nid_back" alt=""></td>
              </tr>-->
              <template>
                <div class="demo-alignment">
                  <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive">
                    <img class="nidImgPrev"  :src="userInfo.ekyc.parsonal.nid_photo" alt="">
                  </vs-popup>
                </div>
              </template>
              <template>
                <div class="demo-alignment">
                  <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive3">
                    <img class="nidImgPrev" :src="userInfo.ekyc.parsonal.nid_back" alt="">
                  </vs-popup>
                </div>
              </template>
            </table>
          </div>
          <!-- /Information - Col 2 -->
        </div>

      </vx-card>
      <vx-card v-if="userInfo.ekyc.contact !== null" title="Contact Information">
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Mobile</td>
              <td> {{ userInfo.ekyc.phone }}</td>
            </tr>
            <tr v-if="userInfo.ekyc.contact.other_phone">
              <td class="font-semibold">Other Phone</td>
              <td><span v-if="userInfo.ekyc.contact.other_phone !== null || userInfo.ekyc.contact.other_phone !== ''">{{ userInfo.ekyc.contact.other_phone}}</span></td>
            </tr>
            <tr>
              <td class="font-semibold">Email</td>
              <td><span v-if="userInfo.ekyc.contact.email !== null || userInfo.ekyc.contact.email !== ''">{{ userInfo.ekyc.contact.email}}</span></td>
            </tr>
          </table>
        </div>
        <br>
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Present Address" class="mb-base">
              <table>
                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.division }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.district }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.thana }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.address }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Nearby Famous Landmark</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.near_landmark}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.postal_code}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Household Type</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.house_hold_type === 'true'?'Yes':'No'}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Living in this address</td>
                  <td>
                    {{ userInfo.ekyc.contact.presentAddress.living_in_this_address.split(',')[0] }} year and {{
                    userInfo.ekyc.contact.presentAddress.living_in_this_address.split(',')[1] }} month
                  </td>
                </tr>
              </table>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Permanent Address" class="mb-base">
              <table>
                <tr>
                  <td>Permanent Address from NID</td>
                  <td>{{userInfo.ekyc.contact.permanentAddress.address_frm_nid}}</td>
                </tr>
<!--                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pdivision }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pdistrict }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pthana }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.paddress }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Nearby Famous Landmark</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pnear_landmark}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.ppostal_code}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Household Type</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.phouse_hold_type === 'true'?'Yes':'No'}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Living in this address</td>
                  <td>
                    {{ userInfo.ekyc.contact.permanentAddress.pliving_in_this_address.split(',')[0] }} year and {{
                    userInfo.ekyc.contact.permanentAddress.pliving_in_this_address.split(',')[1] }} month
                  </td>
                </tr>-->
              </table>
            </vx-card>
          </div>
        </div>
      </vx-card>
      <br>
      <!--      Occupation and dependant-->
      <div class="vx-row">
        <div v-if="userInfo.ekyc.occupation !== null"  class="vx-col lg:w-1/2 w-full">
          <vx-card title="Occupation Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Occupation Type</td>
                <td>{{ userInfo.ekyc.occupation.occupation_type }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Organization Type</td>
                <td>{{ userInfo.ekyc.occupation.occupation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Monthly Income in BDT</td>
                <td>{{ userInfo.ekyc.occupation.monthly_income }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Name of the Office/Business/Source of Income</td>
                <td>{{ userInfo.ekyc.occupation.name_of_Office_or_business }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Designation</td>
                <td>{{ userInfo.ekyc.occupation.designation}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Job length</td>
                <td v-if="userInfo.ekyc.occupation.job_length !==null">{{ year}} year and {{month}} month</td>
              </tr>
              <tr>
                <td class="font-semibold">Division</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.division}}</td>
              </tr>
              <tr>
                <td class="font-semibold">District</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.district}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Thana</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.thana}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Office Area</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.office_area}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.address}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Postal code</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.postal_code}}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card v-if="userInfo.ekyc.dependent !== null" title="Dependent Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">No. of Children living with you</td>
                <td>&nbsp; &nbsp;{{ userInfo.ekyc.dependent.number_of_child }}</td>
              </tr>
              <tr>
                <td class="font-semibold">No. of other dependent living with you</td>
                <td>&nbsp; &nbsp;{{ userInfo.ekyc.dependent.number_of_dependent }}</td>
              </tr>
              <br>
              <!--<tr>
                <td class="font-semibold">Relation</td>
                <td class="font-semibold">Name</td>
                <td class="font-semibold">Age</td>
              </tr>
              <tr v-for="(dependent, index) in userInfo.ekyc.dependent.depandantDetails" :key="index">
                <td>{{ dependent.relation }}</td>
                <td>{{ dependent.name }}</td>
                <td>{{ dependent.age }}</td>
              </tr>-->
            </table>
            <vs-table stripe  v-if="dependentDetailsArr !== null" style="max-height: 235px; overflow: scroll; width: 100%">
              <template slot="thead">
                <vs-th>Relation</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Age</vs-th>
              </template>
              <template>
                <vs-tr  v-for="(dependent, indextr) in dependentDetailsArr" :key="indextr">
                  <vs-td>
                    {{dependent.relation}}
                  </vs-td>
                  <vs-td>
                    {{dependent.name}}
                  </vs-td>
                  <vs-td>
                    {{dependent.age}}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <!-- Showroom and Product  -->
      <div class="vx-row">
        <div v-if="purchaseInfo !== null"  class="vx-col lg:w-1/2 w-full">
          <vx-card title="Showroom Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Address</td>
                <td>{{ purchaseInfo.showroom.address }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Manager Name</td>
                <td>{{ purchaseInfo.showroom.manager_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone</td>
                <td>{{ purchaseInfo.showroom.phone }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card v-if="purchaseInfo !== null" title="Product Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Product Name</td>
                <td>{{ purchaseInfo.product.product }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Brand</td>
                <td>{{ purchaseInfo.brand }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Price Range</td>
                <td>{{ purchaseInfo.price_range }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Used location</td>
                <td>{{ purchaseInfo.used_location }}</td>
              </tr>

            </table>
          </vx-card>
        </div>
      </div>
        <template>
          <div class="demo-alignment">
            <vs-popup classContent="popup-example" fullscreen title="Terms & Conditions: শর্তসমূহঃ" :active.sync="popupActive2">
              <vs-row>
                <vs-col vs-offset="3"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                  <div class="agreement-body">
                    <h4>Terms & Conditions: শর্তসমূহঃ</h4>
                    <div class="parent_dv">
                      <ul>
                        <li>1.</li>
                        <li>The guarantor’s do jointly and severally agree and undertake that their obligations shall be concurrent with the hirer’s as through in all respects each of them was himself/herself the hirer and jointly and severally guarantee to the owner:</li>
                      </ul>
                      <ul>
                        <li>১.</li>
                        <li>
                          নিশ্চয়তাপ্রদানকারীগণ যৌথ ও এককভাবে সম্মত ও অঙ্গিকার প্রদান করছেন যে, তাদের দায়দায়িত্ব ভাড়াগ্রহিতার মত একই রকম হইবে। সার্বিকভাবে তারা প্রত্যেকে নিজেই ভাড়া গ্রহিতা এবং যৌথ ও এককভাবে মালিককে  নিশ্চয়তা প্রদান করিতেছে।
                        </li>
                      </ul>
                    </div>
                    <div class="child_dv">
                      <ul>
                        <li>a.</li>
                        <li>Regular and punctual payment of all monthly hiring rentals hereby provided and</li>
                      </ul>
                      <ul>
                        <li>ক.</li>
                        <li>নিয়মিত এবং সময়োপযোগীভাবে উল্লেখিত মাসিকভাড়া প্রদান করিবেন এবং</li>
                      </ul>
                      <ul>
                        <li>b.</li>
                        <li>b.	Payment to the owner of all money becoming payable to it under or by virtue of this agreement either by way of debt or hire or costs or expenses or otherwise howsoever.</li>
                      </ul>
                      <ul>
                        <li>খ.</li>
                        <li>অত্র চুক্তির অধীনে ঋণ বা কিস্তি বা খরচ সহ মালিককে প্রদেয় অন্য কোন পাওনা পরিশোধ করিবেন।</li>
                      </ul>
                    </div>
                    <div class="parent_dv">
                      <ul>
                        <li>2</li>
                        <li>The guarantor’s further agree:</li>
                      </ul>
                      <ul>
                        <li>২.</li>
                        <li>নিশ্চয়তা প্রদানকারীগণ আরও সম্মত হলেন যেঃ</li>
                      </ul>
                    </div>
                    <div class="child_dv">
                      <ul>
                        <li>a.</li>
                        <li>That the owner shall be at liberty to sue the hirer and the guarantors jointly and/or severally and the guarantors further agree that the owner shall be entitled to proceed against the guarantors only in the first instance, either jointly and/or severally.</li>
                      </ul>
                      <ul>
                        <li>ক.</li>
                        <li>মালিক, ভাড়াগ্রহিতা এবং জামিনদারদের বিরুদ্ধে একক অথবা যৌথভাবে মামলা কারার ক্ষেত্রে স্বাধীনতা ভোগ করিবেন এবং জামিনদারগন আরও সম্মত হলেন যে, মালিক প্রথমেই নিশ্চয়তা প্রদানকারীদের বিরুদ্ধে একক বা যৌথভাবে আইনগত ব্যবস্থা গ্রহণ করিতে পারিবেন।</li>
                      </ul>
                      <ul>
                        <li>b.</li>
                        <li>That the neglect or forborne of the owner in enforcing payment of any money due under this agreement or any other indulgence shown to the Hirer shall not release hirer or the guarantors from their several obligations under this agreement or in any way after the obligation of the hirer and/or guarantors hereunder and shall not in any way affect the rights to the owner in hereunder.</li>
                      </ul>
                      <ul>
                        <li>খ.</li>
                        <li>অত্র চুক্তি অনুযায়ী প্রাপ্য কোন অর্থ আদায়ের ক্ষেত্রে মালিকের কোন অবহেলা বা বিরতি অথবা অন্য কোন আনুকুল্য ভাড়াগ্রহিতা বা জামিনদারদের অত্র চুক্তি অথবা অন্যকোনভাবে বিভিন্ন বাধ্যবাধকতা থেকে মুক্তি দিবে না এবং কোনভাবে মালিকের অধিকার ক্ষুন্ন করবে না। </li>
                      </ul>


                    </div>
                    <h5>Important</h5>
                    <p>The agreement has been read by/to me in my own language and I hereby declare that I have understood the
                      contents of this document.</p>
                    <br>
                    <h5>জরুরী</h5>
                    <p>এই চুক্তিনামা আমার নিজের ভাষায় আমাদ্ব্ারা পাঠিত/আমাকে পাঠ করিয়া শুনানো হইয়াছে এবং আমি ঘোষণা করিতেছি যে আমি
                      এই দলিলের বিষয়বস্তু বুঝিতে পারিয়াছি।</p>
                    <br>
                    <br>
                    <div class="vx-row">
                      <div class="vx-col w-full ">
                        <template>
                          <ul class="centerx">
                            <li>
                              <vs-checkbox v-model="acceptTermAndCondition">I accept Terms & Conditions</vs-checkbox>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </vs-row>

              <div class="vx-row text-right">
                <div class="vx-col w-full text-right">
                  <vs-button  color="danger" class="mr-3 mb-2 float-right"  @click="acceptGuarantor(3)">Reject</vs-button>
                  <vs-button :disabled="acceptTermAndCondition === ''"  color="success" class="mr-3 mb-2 float-right"  @click="acceptGuarantor(2)">Accept</vs-button>
                </div>
              </div>

            </vs-popup>
          </div>
        </template>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button class="mr-3 mb-2" color="rgb(0 121 193)"  @click="popupActive2=true" >View terms & condition and continue</vs-button>
        </div>
      </div>
      <br>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import acceptReject from '../graphql/GuarantorAcceptAndReject.gql'
  import {ME} from '../graphql/userinfo'
  import gql from 'graphql-tag'


  export default {
    data () {
      return {
        year:'',
        month:'',
        userInfo: {
          ekyc:{
            parsonal :{},
            contact :{
              presentAddress:{},
              permanentAddress:{},
            },
            occupation:{

            },
            dependent :{},
            purchaseInfo :{}
          }
        },
        dependentDetailsArr: [],
        guarantorId :'',
        ekycId : '',
        popupActive2: false,
        acceptTermAndCondition:'',
        popupActive: false,
        popupActive3: false,
        gPhone:'',
        gStatus:null,
        guarantorStatus:''
      }
    },
    apollo: {
      guarantor: {
        query: gql`
          query guarantor($token: String!){
            guarantor(token: $token){
              id
              name
              phone
              email
              status
              purchase{
                id
                used_location
                product{
                  id
                  product
                }
                price_range
                brand
                showroom{
                  id
                  address
                  phone
                  manager_name
                }
                user{
                  id
                  name
                  phone
                  ekyc{
                    phone
                    status
                     parsonal{
                      id
                      name
                      last_name
                      father_name
                      mother_name
                      spouse_name
                      age
                      marital_status
                      gender
                      head_of_household
                      education_level
                      nid
                      nid_front
                      nid_back
                      photo
                      nid_photo
                    }
                    contact{
                      id
                      mobile
                      other_phone
                      email
                      presentAddress{
                        id
                        division
                        district
                        thana
                        address
                        near_landmark
                        postal_code
                        house_hold_type
                        living_in_this_address
                      }
                      permanentAddress{
                        id
                        pdivision
                        pdistrict
                        pthana
                        paddress
                        pnear_landmark
                        ppostal_code
                        phouse_hold_type
                        pliving_in_this_address
                        address_frm_nid
                      }
                    }
                    occupation{
                      id
                      occupation_type
                      occupation
                      monthly_income
                      name_of_Office_or_business
                      designation
                      job_length
                      occupationAddress{
                        id
                        division
                        district
                        thana
                        office_area
                        address
                        postal_code
                      }
                    },
                    dependent{
                      id
                      number_of_child
                      number_of_dependent
                      depandantDetails{
                        id
                        relation
                        name
                        age
                      }
                    }
                  }
                }
              }
              ekyc{
                id
                phone
                status
              }

            }
          }
        `,
        variables () {
          // Use vue reactive properties here
          return {
            token: this.$route.params.token
          }
        },
        update: (data) => data.guarantor
      },
      userByPhone:{
        query:gql`
        query userByPhone($phone: String!){
          userByPhone(phone: $phone){
            id
            phone
            ekyc {
              id
            }
          }
        }
        `,
        variables () {
          // Use vue reactive properties here
          return {
            phone: this.gPhone
          }
        },
        update: (data) => data.userByPhone
      }
    },
    watch:{
      guarantor(value){
        this.gPhone = value.phone;
        if(value.status === 4){
          this.$router.push('/greetings-submission').catch(() => {})
        }else if(value.status === 3){
          this.$router.push('/reject-submission').catch(() => {})
        }
        this.purchaseInfo = value.purchase;
        this.userInfo = value.purchase.user;
        this.guarantorId = value.id;
        this.guarantorStatus = value.status;
        this.ekycId = value.ekyc.id;
        this.dependentDetailsArr = this.userInfo.ekyc.dependent.depandantDetails;
        var ar = this.userInfo.ekyc.occupation.job_length.split(',');
        this.year = ar[0]
        this.month = ar[1]
        console.log("value =====1 :", this.guarantorStatus);
      },
      userByPhone(val){
        console.log("value ===== :", val);
        console.log("value =====2 :", this.guarantorStatus);
        this.gStatus = val;
        if(this.guarantorStatus === 2){
          if(this.gStatus !== null){
            this.$router.push('/guarantorInfos/'+this.guarantorId+'/'+this.ekycId).catch(() => {})
          }else {
            this.$router.push('/pages/guarantor-register/'+this.guarantorId+'/'+this.ekycId).catch(() => {})
          }
        }
        console.log("G Status ==: ", this.gStatus);
      },

    },
    methods: {
      async acceptGuarantor (status) {
        console.log("222222===>>", this.guarantorId);
        await this.$apollo.mutate({
          mutation: acceptReject,
          variables: {
            id: this.guarantorId,
            status: status,
          }
        }).then((data) => {
          this.popupActive2 = false;
          this.guarantorId = data.data.acceptOrRejectByGuarantor.id;
          this.ekycId = data.data.acceptOrRejectByGuarantor.ekyc.id;
          if(this.gStatus !== null){
            this.$router.push('/guarantorInfos/'+this.guarantorId+'/'+this.ekycId).catch(() => {})
          }else {
            this.$router.push('/pages/guarantor-register/'+this.guarantorId+'/'+this.ekycId).catch(() => {})
          }
          this.$apollo.queries.user.refetch();
          this.$vs.notify({
            title: 'Accept Or Reject',
            text: 'Accept',
            color: "success",
            position: 'top-right'
          })
        }).catch((error) => {
        })

      },
      // async acceptGuarantor () {
      //
      //   this.$router.push('/guarantorInfos/'+this.guarantorId+'/'+this.ekycId).catch(() => {
      //   })
      // },
    }
  }
</script>

<style>
  .vx-col table tr > td {
    /*vertical-align: top;*/
    min-width: 250px;
    /*word-break: break-all;*/
  }
  #page-user-view table td {
    /*vertical-align: top;*/
    min-width: 250px;
    /*word-break: break-all;*/
  }
  .nav-img-for-gu img {
    height: 55px;
    padding: 5px 0;
  }
  #user-data {
    padding: 15px 30px;
  }
  .not-data-table.vs-table--not-data {
    display: none;
  }
  .img-container.mb-4 img {
    height: 130px;
  }
  img.nidImg {
    height: 130px;
    cursor: pointer;
  }
  img.nidImgPrev {
    height: 275px;
    width: auto;
    border-radius: 7px;
  }
  @media only screen

  and (min-device-width: 375px)

  and (max-device-width: 768px)

  and (-webkit-min-device-pixel-ratio: 2)

  and (orientation: portrait) {
    #page-user-view table td {
      font-size: 9pt;
    }
    .vx-col table tr > td {
      min-width: auto;
      font-size: 9pt;
    }

    #page-user-view table td {
      min-width: auto;
      font-size: 9pt;
    }
  }

  @media only screen

  and (min-device-width: 375px)

  and (max-device-width: 768px)

  and (-webkit-min-device-pixel-ratio: 2)

  and (orientation: landscape) {
    #page-user-view table td {
      font-size: 9pt;
    }
    .vx-col table tr > td {
      min-width: auto;
      font-size: 9pt;
    }

    #page-user-view table td {
      min-width: auto;
      font-size: 9pt;
    }
  }
</style>
